import { Box, Icon, Text, getThemeColor } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { ChartImage } from '../../../pages/Dashboard/components/ChartImage/chart-image.comp'
import { getReadableNumber } from '../../../utilities/strings/getReadableNumber'
import { DashboardCardMenu } from '../DashboardCardMenu/dashboard-card-menu.comp'

import * as Styles from './dashboard-highlight-card.styles'
import { DashboardHighlightCardProps } from './dashboard-highlight-card.types'

export const DashboardHighlightCard = ({
  title,
  icon,
  value,
  details,
  url,
  color,
  ...rest
}: DashboardHighlightCardProps) => {
  const theme = useTheme()

  return (
    <Styles.Card
      gap={2}
      padding={4}
      direction="column"
      width="100%"
      justifyContent="center"
      {...rest}
    >
      <DashboardCardMenu title={title} details={details} url={url} />

      <Box gap={2} alignItems="center">
        <Styles.IconContainer>
          <Icon name={icon} color={color} size={24} />
        </Styles.IconContainer>
        <Text fontWeight={500}>{title}</Text>
      </Box>

      <Box
        gap={2}
        alignItems="flex-end"
        justifyContent="space-between"
        width="100%"
      >
        <Box flex={1}>
          <Styles.CardValue>{getReadableNumber(value)}</Styles.CardValue>
        </Box>
        <Box>
          <ChartImage color={getThemeColor(color, theme)} size={130} />
        </Box>
      </Box>
    </Styles.Card>
  )
}
